/* eslint-disable @typescript-eslint/no-var-requires, import/no-commonjs */
import * as React from 'react';
import styled from 'styled-components';
import { Table, TableProps } from 'antd';
import errorReporter from '@app/errorReporter';

import { BasicContact, VirtualTourJsonType } from '@bb/domain/dist/types';

import StepHeaders from '../StepHeaders';
import VirtualTourModal from './VirtualTourModal';
import Loading from '../../../../react-common/Loading';
import { useGetVirtualToursForDash } from './hooks';

const styles = require('../appointment_book.module.scss');

interface VtStep2SelectTourProps {
  listingId: string;
  currentStep?: number;
  coop: BasicContact;
  updateState: (draft: Record<string, any>) => void;
  dashboardId: string;
  retsId: string;
}

interface FinalTours extends VirtualTourJsonType {
  key: string;
}

const VtStep2SelectTour: React.FC<VtStep2SelectTourProps> = ({
  currentStep = 1,
  coop,
  updateState,
  listingId,
  dashboardId,
  retsId,
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const [shouldGetTours, setShouldGetTours] = React.useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [createdRoom, setCreatedRoom] = React.useState(null);

  const { tours, isLoading } = useGetVirtualToursForDash({
    coop,
    dashboardId,
    retsId,
    listingId,
    setCreatedRoom,
    createdRoom,
    setShouldGetTours,
    shouldGetTours,
    updateState,
    setSelectedRowKeys,
  });

  const closeModal = (requireUpdate = false) => {
    setShouldGetTours(requireUpdate);
    setShowModal(false);
  };

  const addDatacy =
    (key: string) =>
    ({ id }: { id: string }) =>
      ({ 'data-cy': `${key}-${id}` }) as React.HTMLAttributes<HTMLElement>;

  // table
  const columns: TableProps<FinalTours>['columns'] = [
    {
      title: 'Name of Tour',
      dataIndex: 'tourName',
      onCell: addDatacy('tour-name'),
    },
    {
      title: '# of Listings',
      dataIndex: 'listings',
      onCell: addDatacy('tour-listings'),
    },
    {
      title: 'Date / Time',
      dataIndex: 'startTime',
      onCell: addDatacy('tour-date'),
    },
  ];
  const onSelectChange = (key: any) => {
    setSelectedRowKeys(key);
  };

  return (
    <div
      className={`form-group col-md-5 ${
        currentStep === 1 ? styles.stepActive : styles.stepInactive
      }`}
    >
      <StepHeaders stepNumber={1} stepTitle="Select Tour Name" />

      <VirtualTourModal
        setCreatedRoom={setCreatedRoom}
        coop={coop}
        visible={showModal}
        closeModal={closeModal}
        dashboardId={dashboardId}
        retsId={retsId}
      />
      {isLoading ? (
        <Loading size="fa-5x" />
      ) : (
        <StyledDivBody>
          {tours && tours.length ? (
            <Table
              columns={columns}
              dataSource={tours}
              rowSelection={{
                onSelect: tour =>
                  updateState((draft: any) => {
                    draft.selectedTour = { ...tour, invitees: draft.invitees };
                  }),
                selectedRowKeys,
                onChange: onSelectChange,
                type: 'radio',
              }}
              pagination={false}
            />
          ) : (
            <StyledDiv>
              <h4>You have no tours</h4>
            </StyledDiv>
          )}
          <StyledDiv>
            <br />
            <button
              onClick={() => setShowModal(true)}
              className={`btn btn-primary ${
                tours && tours.length ? 'pull-right' : ''
              }`}
              data-cy="create-new-button"
            >
              + Create New Tour
            </button>
            <br />
          </StyledDiv>
        </StyledDivBody>
      )}
    </div>
  );
};

export default VtStep2SelectTour;

const StyledDivBody = styled.div`
  width: 95%;
  margin: auto;
`;

const StyledDiv = styled.div`
  padding-top: 3%;
  width: 70%;
  margin: auto;
  text-align: start;
`;
